import { render, staticRenderFns } from "./TyphoonFlood.vue?vue&type=template&id=a249dd1e&scoped=true&"
import script from "./TyphoonFlood.vue?vue&type=script&lang=js&"
export * from "./TyphoonFlood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a249dd1e",
  null
  
)

export default component.exports